import { createSlice } from '@reduxjs/toolkit';

const contactFormSlice = createSlice({
  name: 'contactForm',
  initialState: {
    loading: false,
    success: false,
    error: false,
    errorMessage: '',
    data: {
      comments: '',
      email: '',
      file: null,
      name: '',
    },
  },
  reducers: {
    contactFormSubmit(state) {
      state.loading = true;
      state.success = false;
      state.error = false;
      state.errorMessage = '';
    },
    contactFormSubmitSuccess(state) {
      state.success = true;
      state.loading = false;
    },
    contactFormSubmitError(state, { payload }) {
      state.success = false;
      state.error = true;
      state.errorMessage =
        payload.data?.detail || payload || 'Sorry, something went wrong';
      state.loading = false;
    },
  },
});

export const {
  contactFormSubmit,
  contactFormSubmitSuccess,
  contactFormSubmitError,
} = contactFormSlice.actions;

export default contactFormSlice.reducer;
